import { render, staticRenderFns } from "./MenuItemPrice.vue?vue&type=template&id=28207698&scoped=true&"
import script from "./MenuItemPrice.vue?vue&type=script&lang=js&"
export * from "./MenuItemPrice.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemPrice.vue?vue&type=style&index=0&id=28207698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28207698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
